import * as React from "react";

function SvgComponent(props) {
  return <svg id="svg7384" style={{
    enableBackground: "new"
  }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.00585 16" width="1em" height="1em" {...props}><title id="title8473">{"Gnome Symbolic Icons"}</title><defs id="defs7386" /><g id="layer10" transform="translate(-332,-852)" /><g id="layer1" transform="translate(-332,-788)" /><g id="layer11" transform="translate(-332,-852)" /><g id="layer7" transform="translate(-332,-788)" /><g id="layer6" transform="translate(-332,-788)" /><g id="layer5" transform="translate(-332,-788)" /><g id="layer9" transform="translate(-332,-788)" /><g id="layer2" transform="translate(-332,-788)" /><g id="layer8" transform="translate(-332,-788)" /><g id="layer3" transform="translate(-332,-788)" /><g id="layer4" transform="translate(-332,-788)"><path d="m 338,789 c -1.65685,0 -3,1.34315 -3,3 0,1.65685 1.34315,3 3,3 1.65685,0 3,-1.34315 3,-3 0,-1.65685 -1.34315,-3 -3,-3 z m -1.5,7 c -2.493,0 -4.5,2.007 -4.5,4.5 v 1.5 c 0,1 1,1 1,1 h 10 c 0,0 1,0 1,-1 v -1.5 c 0,-2.493 -2.007,-4.5 -4.5,-4.5 z" id="path4144" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1.84615,
        marker: "none",
        enableBackground: "accumulate"
      }} /><path d="m 344.00584,789.00326 v 1.99673 h -1.99999 v 1.99673 h 1.99999 v 1.99673 h 2.00001 v -1.99673 h 2 v -1.99673 h -2 v -1.99673 z" id="path4360" style={{
        display: "inline",
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        enableBackground: "new"
      }} /></g></svg>;
}

export default SvgComponent;